<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Add an additional cost to {{huov.huov_code }}  {{huov.huov_nr}}</p>
    <v-form ref="addHokp" v-model="addHokpValid">
     <v-row no-gutters>
       
      <v-col class="ma-2">
        <v-select v-model="kstp_nr" @input="runStep2()" required :items="kstp_nrKeuzes" item-value="kstp_nr" item-text="kstptaal_oms" label="Costs" dense :rules="kstp_nrRules"></v-select>      
      </v-col>
     </v-row>  

     <v-row v-if="kstp_nr > 0" no-gutters>
       <v-col class="ma-2">
         <v-select v-model="huov.ktpz_nr" required :items="ktpz_nrKeuzes" item-value="ktpz_nr" item-text="ktpztaal_oms" label="Sentence" dense></v-select>      
       </v-col>  
     </v-row>  

     <v-row v-if="kstp_nr > 0" no-gutters>
       <v-col class="ma-2">
         <v-select v-model="huov.huov_betaling" required :items="huov_betalingKeuzes" item-value="id" item-text="desc" label="Payment" dense :rules="huov_betalingRules"></v-select>      
       </v-col>  
     </v-row>  

     <v-row v-if="kstp_nr > 0 && kstp.sign_matje == 'yes'" no-gutters>
       <v-col class="ma-2">
          <v-text-field v-model="huov.hokp_gtl_verk" :prefix='sign_matje_prefix' :suffix='sign_matje_suffix' :rules="hokp_gtl_verkRules"></v-text-field>
       </v-col>  
     </v-row>  

     <v-row v-if="kstp_nr > 0 && kstp.kstp_mndb != 'No'" no-gutters>
      <v-col cols="4" class="px-2">
        <v-menu
          v-model="huov.hokp_van_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="huov.hokp_van_dat"
            label="Arrival from"
            v-on="on"
            clearable
            hint="Only enter a date when the cost is not applicable for the whole year or starts at a certain date"
          ></v-text-field>
        </template>
        <v-date-picker v-model="huov.hokp_van_dat" :first-day-of-week="1" @input="huov.hokp_van_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col> 
      <v-col cols="4" class="px-2">
        <v-menu
          v-model="huov.hokp_tm_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="huov.hokp_tm_dat"
            label="Arrival until"
            v-on="on"
            clearable
            hint="Only enter a date when the cost is not applicable for the whole year or ends at a certain date"
          ></v-text-field>
        </template>
        <v-date-picker v-model="huov.hokp_tm_dat" :first-day-of-week="1" @input="huov.hokp_tm_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col> 
      <v-col v-if="huov.hokp_van_dat > '' && huov.hokp_tm_dat > ''" cols="4" class="px-2">
        <v-checkbox v-model="huov.hokp_verlenging" label="Every year"></v-checkbox>
      </v-col>  
     </v-row>  

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHokp" :disabled="!addHokpValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addHokpValid: false,
      huov_encrid: null,
      huov: {},
      kstp: {},
      kstp_nr: 0,
      sign_matje_prefix: '',
      sign_matje_suffix: '',
      kstp_nrKeuzes: [],
      huov_betalingKeuzes: [],
      ktpz_nrKeuzes: [],
      kstp_nrRules: [
          v => !!v || "A Cost is required"
      ],
      huov_betalingRules: [
          v => !!v || "A way of Payment is required"
      ],
      hokp_gtl_verkRules: [
          v => !!v || "An amount is required"
      ],           
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.$axios
        .post("ares/json/ares/huov/hokp/getHuovToAddHokp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovToAddHokp"
          },
          getHuovToAddHokp: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovToAddHokp;
            res.data.getHuovToAddHokp.kstp_nrKeuzes.forEach(function(kstp) {
            deze.kstp_nrKeuzes.push(kstp); 
            });
            deze.huov_encrid = huov_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    runStep2() {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hokp_van_dat = '';
      this.hokp_tm_dat = '';
      this.ktpz_nrKeuzes.length = 0;
      this.$axios
        .post("ares/json/ares/huov/hokp/getKstpToAddHokp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKstpToAddHokp"
          },
          getKstpToAddHokp: {
            huov_encrid: this.huov.huov_encrid,
            kstp_nr: this.kstp_nr
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            
            res.data.getKstpToAddHokp.ktpz_nrKeuzes.forEach(function(element,index) {
            deze.ktpz_nrKeuzes.push(element); 
            if (index==0) deze.huov.ktpz_nr = element.id;
            });

            res.data.getKstpToAddHokp.huov_betalingKeuzes.forEach(function(element,index) {
            deze.huov_betalingKeuzes.push(element); 
            if (index==0) deze.huov.huov_betaling = element.id;
            });
            this.kstp = res.data.getKstpToAddHokp;
            this.sign_matje_prefix = this.kstp.sign_matje_prefix;
            this.sign_matje_suffix = this.kstp.sign_matje_suffix;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHokp() { 
      this.$axios
        .post("ares/json/ares/huov/hokp/addHokp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHokp"
          },
          addHokp: {
            huov_encrid: this.huov.huov_encrid,
            kstp_nr: this.kstp_nr,
            hokp_van_dat: this.huov.hokp_van_dat,
            hokp_tm_dat: this.huov.hokp_tm_dat,
            hokp_verlenging: this.huov.hokp_verlenging,
            hokp_gtl_verk: parseFloat(this.huov.hokp_gtl_verk),
            hokp_betaling: this.huov.huov_betaling,
            ktpz_nr: parseInt(this.huov.ktpz_nr)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
             if (res.data.addHokp.color == "success") {
                this.$router.reload('/huov/onHuov/' + res.data.addHokp.huov_encrid);  
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHokp.text,
              color: res.data.addHokp.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

